import React from 'react'
import { ScrollParallax } from 'react-just-parallax'
import useMediaQuery from '../Hooks/useMediaQuery'
import Link from '../PageComponents/Link'
import { setMargin, setPadding } from '../utilities'

export default function BioSection ({
  pageName,
  sub_title,
  title,
  body,
  button_text,
  bio_image,
  margin_selection,
  padding_selection,
  background_color
}) {
  const pageStyles = {
    ...(background_color && {
      background:
        `linear-gradient(180deg, #EDC37800 0%, ${background_color} 100%)` ||
        'light-gray'
    }),
    ...(setMargin(margin_selection) && { margin: setMargin(margin_selection) }),
    ...(setPadding(padding_selection) && {
      padding: setPadding(padding_selection)
    })
  }
  const isAbsolute = useMediaQuery('(min-width:1024px)')
  return (
    <div
      style={{ ...pageStyles }}
      className='flex items-center justify-center w-full'
      id={pageName}
    >
      <div className='flex items-center justify-center m-auto p-4 lg:py-24 max-w-sitemax px-8 2xl:px-0'>
        <div className='relative flex-col-reverse lg:flex-row  flex items-center justify-center m-auto'>
          <div className='flex flex-col max-w-xl items-start translate-x-0 lg:-translate-x-1/3'>
            {sub_title && (
              <p className='text-header1 font-bold font-text_highlight text-color_light'>
                {sub_title}
              </p>
            )}
            {title && (
              <h1 className='text-mini_giant md:text-giant font-bold font-text_highlight text-color_light leading-[9rem] mb-4'>
                {title}
              </h1>
            )}
            {bio_image && (
              <ScrollParallax
                strength={0.03}
                isAbsolutelyPositioned={isAbsolute}
                zIndex={-1}
              >
                <img
                  className=' w-full h-full object-contain relative lg:absolute left-[unset] translate-x-0 lg:left-full lg:-translate-x-1/4'
                  src={bio_image}
                  title={title}
                  alt='the Author'
                />
              </ScrollParallax>
            )}
            {body && (
              <div
                className='text-header4 font-text_readable text-color_light mb-6'
                dangerouslySetInnerHTML={{
                  __html: body
                }}
              />
            )}
            {button_text && (
              <Link
                url={button_text?.url}
                className='font-medium cursor-pointer uppercase btn btn_white text-center px-0 lg:px-10 py-3 btn_sm w-full lg:w-auto max-w-[90dvw]'
              >
                {button_text?.title || 'Learn More'}
              </Link>
            )}
          </div>
        </div>
      </div>
    </div>
  )
}
